import { useEffect, useState } from "react";
import styles from "./TimeTracking.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import WeekViewTable from "./WeekViewTable";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import Filter from "./Filter";
import DayViewTable from "./DayViewTable";

dayjs.extend(isoWeek);

// ─── Static data ──────────────────────────────────────────────────────────────
const DAY_LABELS = ["Mon 5", "Tue 6", "Wed 7", "Thu 8", "Fri 9", "Sat 10", "Sun 11"];
const HOUR_LABELS = ["Sign In", "Sign out", "hours", "status"];
const DAY_VIEW_IDX = 4; // Fri 9 is the "today" for day view

const EMPLOYEES = [
  {
    id: "pl", initials: "PL", avKey: "avPl", name: "Priya Lal", role: "Prop. Manager",
    total: "35h 12m", totalOt: false,
    days: [
      { h: "8h 56m", ci: "8:02", co: "4:58", ciH: 8.03, coH: 16.97, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 536, otMin: 0, late: false },
      { h: "9h 01m", ci: "8:00", co: "5:01", ciH: 8, coH: 17.02, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 541, otMin: 1, late: false },
      { h: "8h 30m", ci: "8:05", co: "4:35", ciH: 8.08, coH: 16.58, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 510, otMin: 0, late: false },
      { h: "8h 45m", ci: "7:58", co: "4:43", ciH: 7.97, coH: 16.72, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 525, otMin: 0, late: false },
      { today: true }, null, null,
    ],
  },
  {
    id: "tw", initials: "TW", avKey: "avTw", name: "Troy Williams", role: "Maintenance",
    total: "41h 19m", totalOt: true,
    days: [
      { h: "8h 10m", ci: "7:50", co: "4:00", ciH: 7.83, coH: 16, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 490, otMin: 0, late: false },
      { h: "7h 42m", ci: "9:18", co: "5:00", ciH: 9.3, coH: 17, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 462, otMin: 0, late: true, shortBy: "18m" },
      { h: "8h 05m", ci: "7:55", co: "4:00", ciH: 7.92, coH: 16, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 485, otMin: 0, late: false },
      { h: "8h 00m", ci: "7:48", co: "3:48", ciH: 7.8, coH: 15.8, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 480, otMin: 0, late: false },
      { h: "9h 22m", ci: "8:00", co: "5:22", ciH: 8, coH: 17.37, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "17:22", schedStartH: 8, schedEndH: 17, target: 540, worked: 562, otMin: 22, late: false, noOut: true },
      null, null,
    ],
  },
  {
    id: "ch", initials: "CH", avKey: "avCh", name: "Carmen Hess", role: "Leasing Agent",
    total: "31h 50m", totalOt: false,
    days: [
      { h: "8h 00m", ci: "9:00", co: "5:00", ciH: 9, coH: 17, sched: "9:00 AM – 5:00 PM", schedStart: "09:00", schedEnd: "17:00", schedStartH: 9, schedEndH: 17, target: 480, worked: 480, otMin: 0, late: false },
      { h: "8h 00m", ci: "9:00", co: "5:00", ciH: 9, coH: 17, sched: "9:00 AM – 5:00 PM", schedStart: "09:00", schedEnd: "17:00", schedStartH: 9, schedEndH: 17, target: 480, worked: 480, otMin: 0, late: false },
      null,
      { h: "7h 55m", ci: "9:05", co: "5:00", ciH: 9.08, coH: 17, sched: "9:00 AM – 5:00 PM", schedStart: "09:00", schedEnd: "17:00", schedStartH: 9, schedEndH: 17, target: 480, worked: 475, otMin: 0, late: false },
      { inProg: true, h: "7h 55m", ci: "8:05", ciH: 8.08, sched: "9:00 AM – 5:00 PM", schedStartH: 9, schedEndH: 17 },
      null, null,
    ],
  },
  {
    id: "mj", initials: "MJ", avKey: "avMj", name: "Marcus Jones", role: "Maintenance",
    total: "25h 46m", totalOt: false,
    days: [
      { h: "6h 30m", ci: "10:00", co: "4:30", ciH: 10, coH: 16.5, sched: "8:00 AM – 5:00 PM", schedStart: "10:00", schedEnd: "16:30", schedStartH: 8, schedEndH: 17, target: 540, worked: 390, otMin: 0, late: true, shortBy: "1h 30m" },
      { h: "8h 00m", ci: "8:00", co: "4:00", ciH: 8, coH: 16, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "16:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 480, otMin: 0, late: false },
      null,
      { h: "8h 00m", ci: "8:00", co: "4:00", ciH: 8, coH: 16, sched: "8:00 AM – 5:00 PM", schedStart: "08:00", schedEnd: "16:00", schedStartH: 8, schedEndH: 17, target: 540, worked: 480, otMin: 0, late: false },
      { inProg: true, h: "3h 16m", ci: "8:00", ciH: 8, sched: "8:00 AM – 5:00 PM", schedStartH: 8, schedEndH: 17 },
      null, null,
    ],
  },
  {
    id: "rl", initials: "RL", avKey: "avRl", name: "Rosa López", role: "Leasing Agent",
    total: "42h 30m", totalOt: false,
    days: [...Array(5)].map(() => ({ h: "8h 30m", ci: "8:00", co: "4:30", ciH: 8, coH: 16.5, sched: "8:00 AM – 4:30 PM", schedStart: "08:00", schedEnd: "16:30", schedStartH: 8, schedEndH: 16.5, target: 510, worked: 510, otMin: 0, late: false })).concat([null, null]),
  },
];

const DAY_NOTES = {
  mj: "unit 4B",
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const pct = (w, t) => Math.min(100, Math.round((w / t) * 100));
const fmtOt = m => "+" + (Math.floor(m / 60) ? Math.floor(m / 60) + "h " : "") + (m % 60 ? m % 60 + "m" : "");
const toP = (h, base = 6, span = 14) => Math.max(0, Math.min(100, ((h - base) / span) * 100));

// ─── DayCell ──────────────────────────────────────────────────────────────────
function DayCell({ d, empId, dayIdx, otState, onOpen }) {
  if (!d) return <span className={`${styles.offLbl}`}>off</span>;

  if (d.today) return (
    <div className={`${styles.todayWrap}`}>
      <span className={`${styles.todayMark}`}>—</span>
      <span className={`${styles.todaySub}`}>today</span>
    </div>
  );

  if (d.inProg) return (
    <button className={`${styles.dayBtn} ${styles.inProg}`} onClick={() => onOpen(empId, dayIdx)}>
      <div className={`${styles.cellTopRow}`}>
        <span className={`${styles.dh} ${styles.dhProg}`}>{d.h}</span>
        <span className={`${styles.cellTag} ${styles.tagProg}`}>live</span>
      </div>
      <div className={`${styles.dtRow}`}>
        <span className={`${styles.dtIn}`}>{d.ci}</span>
        <span className={`${styles.dtSep}`}>→</span>
        <span className={`${styles.dtOut} ${styles.dtOutProg}`}>now</span>
      </div>
      {/* <div className={`${styles.dBar}`}>
        <div className={`${styles.dBarFill}`} style={{width:"55%"}} />
      </div> */}
    </button>
  );

  const isOt = d.otMin > 0;
  const barW = pct(Math.min(d.worked, d.target), d.target);
  const otW = isOt ? Math.round((d.otMin / d.target) * 100) : 0;

  const btnCls = [
    styles.dayBtn,
    otState === "approved" ? styles.resolvedOk :
      otState === "declined" ? styles.resolvedNo :
        isOt ? styles.hasOt :
          d.late ? styles.isLate : "",
  ].join(" ");

  const dhCls = [
    styles.dh,
    isOt && !otState ? styles.dhOt :
      d.late && !otState ? styles.dhLate : "",
  ].join(" ");

  const chip = otState === "approved" ? <span className={`${styles.cellTag} ${styles.tagApproved}`}>✓ OT approved</span>
    : otState === "declined" ? <span className={`${styles.cellTag} ${styles.tagDeclined}`}>OT declined</span>
      : isOt ? <span className={`${styles.cellTag} ${styles.tagOt}`}>{fmtOt(d.otMin)}</span>
        : d.late ? <span className={`${styles.cellTag} ${styles.tagLate}`}>late −{d.shortBy}</span>
          : null;

  const outCls = d.noOut
    ? `${styles.dtOut} ${styles.dtOutMiss}`
    : styles.dtOut;

  return (
    <button className={btnCls} onClick={() => onOpen(empId, dayIdx)}>
      <div className={`${styles.cellTopRow}`}>
        <span className={dhCls}>{d.h}</span>
        {chip}
      </div>
      <div className={`${styles.dtRow}`}>
        <span className={`${styles.dtIn}`}>{d.ci}</span>
        <span className={`${styles.dtSep}`}>→</span>
        <span className={outCls}>{d.noOut ? "!out" : (d.co || "—")}</span>
      </div>
      {/* <div className={`${styles.dBar}`}>
        <div className={`${styles.dBarFill}`} style={{width:`${barW}%`}} />
        {isOt && <div className={`${styles.dBarOt}`} style={{left:`${barW}%`,width:`${otW}%`}} />}
      </div> */}
    </button>
  );
}

function DayViewRow({ emp, dayIdx, otState, onOpen, notes }) {
  const d = emp.days[dayIdx];

  // Day off
  if (!d) return (
    <tr className={`${styles.tbodyTr}`}>
      <td className={`${styles.tdEc}`}>
        <div className={`${styles.empWrap}`}>
          <div className={`${styles.av} ${styles[emp.avKey]}`}>{emp.initials}</div>
          <div>
            <div className={`${styles.empName}`}>{emp.name}</div>
            <div className={`${styles.dvProperty}`}>{emp.property}</div>
          </div>
        </div>
      </td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
      <td className={`${styles.td}`}><span className={`${styles.offLbl}`}>Day off</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
    </tr>
  );

  // Today — no data yet
  if (d.today) return (
    <tr className={`${styles.tbodyTr}`}>
      <td className={`${styles.tdEc}`}>
        <div className={`${styles.empWrap}`}>
          <div className={`${styles.av} ${styles[emp.avKey]}`}>{emp.initials}</div>
          <div>
            <div className={`${styles.empName}`}>{emp.name}</div>
            <div className={`${styles.dvProperty}`}>{emp.property}</div>
          </div>
        </div>
      </td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dvStatusPending}`}>Pending</span></td>
      <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
    </tr>
  );

  const isOt = d.otMin > 0;
  const isLate = d.late;
  const isInProg = !!d.inProg;
  const barW = d.target ? Math.min(100, Math.round((Math.min(d.worked || 0, d.target) / d.target) * 100)) : 0;
  const otW = isOt ? Math.round((d.otMin / d.target) * 100) : 0;

  // Status label
  const statusEl = isInProg
    ? <span className={`${styles.dvStatusProg}`}>In progress</span>
    : isOt && otState === "approved"
      ? <span className={`${styles.dvStatusOk}`}>OT approved</span>
      : isOt && otState === "declined"
        ? <span className={`${styles.dvStatusOff}`}>OT declined</span>
        : isOt
          ? <span className={`${styles.dvStatusOt}`}>Overtime ⚠</span>
          : isLate
            ? <span className={`${styles.dvStatusLate}`}>Late start</span>
            : <span className={`${styles.dvStatusOk}`}>Complete</span>;

  const trCls = [
    styles.dvTr,
    isOt && !otState ? styles.dvTrOt :
      isLate ? styles.dvTrLate :
        isInProg ? styles.dvTrProg : "",
  ].join(" ");

  const hoursColor = isOt ? styles.dvHoursOt : isLate ? styles.dvHoursLate : isInProg ? styles.dvHoursProg : styles.dvHoursOk;

  return (
    <tr
      className={`${styles.tbodyTr}`}
      onClick={() => onOpen(emp.id, dayIdx)}
      style={{ cursor: "pointer" }}
    >
      {/* Employee */}
      <td className={`${styles.tdEc}`}>
        <div className={`${styles.empWrap}`}>
          <div className={`${styles.av} ${styles[emp.avKey]}`}>{emp.initials}</div>
          <div>
            <div className={`${styles.empName}`}>{emp.name}</div>
            <div className={`${styles.dvProperty}`}>{emp.property}</div>
          </div>
        </div>
      </td>

      {/* Clock in */}
      <td className={`${styles.td}`}>
        <span className={`${styles.dh} ${isLate ? styles.dvTimeLate : ""}`}>
          {d.ci ? d.ci + " AM" : "—"}
        </span>
      </td>

      {/* Clock out */}
      <td className={`${styles.td}`}>
        {isInProg
          ? <span className={`${styles.dvInProgLbl}`}>in progress</span>
          : d.noOut
            ? <span className={`${styles.dvInMissingLbl}`}>missing</span>
            : <span className={`${styles.dh}`}>{d.co} PM</span>
        }
      </td>

      {/* Hours + bar */}
      <td className={`${styles.td}`}>
        <div className={`${styles.dvHoursWrap}`}>
          <span className={`${styles.dvHours} ${hoursColor}`}>
            {d.h}{isOt ? " ⚠" : ""}
          </span>
        </div>
      </td>

      {/* Status */}
      <td className={`${styles.td}`}>{statusEl}</td>

      {/* Notes */}
      <td className={`${styles.td}`}>
        {notes
          ? <span className={`${styles.dh}`}>{notes}</span>
          : <span className={`${styles.dh}`}>—</span>
        }
      </td>
    </tr>
  );
}

// ─── DayModal ─────────────────────────────────────────────────────────────────
function DayModal({ emp, dayIdx, otState, onClose, onResolve }) {
  const [shiftOpen, setShiftOpen] = useState(false);
  const [shiftStart, setShiftStart] = useState("");
  const [shiftEnd, setShiftEnd] = useState("");
  const [saved, setSaved] = useState(false);

  const d = emp?.days[dayIdx];
  if (!d || d.today) return null;

  const tH = Math.floor((d.target || 0) / 60);
  const isOt = d.otMin > 0;
  const schedL = toP(d.schedStartH || 8);
  const schedW = toP(d.schedEndH || 17) - schedL;
  const ciL = toP(d.ciH || 8);
  const coHv = d.inProg ? d.ciH + 3 : (d.coH || 17);
  const workedW = Math.max(0, toP(coHv) - ciL);
  const otL = toP(d.schedEndH || 17);
  const otWv = Math.max(0, toP(coHv) - otL);

  const workedCls = isOt
    ? `${styles.irVal} ${styles.irOt}`
    : d.late
      ? `${styles.irVal} ${styles.irLate}`
      : `${styles.irVal} ${styles.irOk}`;

  function handleApply() {
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  }

  function openShift() {
    if (!shiftOpen) { setShiftStart(d.schedStart || "08:00"); setShiftEnd(d.schedEnd || "17:00"); }
    setShiftOpen(v => !v);
  }

  return (
    <div className={`${styles.modalOverlay}`} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`${styles.modal}`}>

        {/* ── Head ── */}
        <div className={`${styles.modalHead}`}>
          <div className={`${styles.mhLeft}`}>
            <div className={`${styles.av} ${styles[emp.avKey]}`} style={{ width: 34, height: 34, fontSize: 10, flexShrink: 0 }}>
              {emp.initials}
            </div>
            <div>
              <div className={`${styles.modalName}`}>{emp.name}</div>
              <div className={`${styles.modalDate}`}>{DAY_LABELS[dayIdx]}, May 2026</div>
            </div>
          </div>
          <button className={`${styles.modalClose}`} onClick={onClose} aria-label="Close">✕</button>
        </div>

        {/* ── Timeline ── */}
        <div className={`${styles.timelineWrap}`}>
          <div className={`${styles.tlLabel}`}>Shift timeline</div>
          <div className={`${styles.tlBarWrap}`}>
            <div className={`${styles.tlTrack}`} />
            <div className={`${styles.tlSched}`} style={{ left: `${schedL}%`, width: `${schedW}%` }} />
            <div className={`${styles.tlWorked}`} style={{ left: `${ciL}%`, width: `${workedW}%` }} />
            {isOt && <div className={`${styles.tlOt}`} style={{ left: `${otL}%`, width: `${otWv}%` }} />}
          </div>
          <div className={`${styles.tlTimes}`}>
            <span>6 AM</span><span>12 PM</span><span>8 PM</span>
          </div>
          <div className={`${styles.tlCiLbl}`}>
            <span className={`${styles.tlBadge} ${styles.tlBadgeIn}`}>{d.ci} AM</span>
            <span className={`${styles.tlArrow}`}>→</span>
            {d.noOut
              ? <span className={`${styles.tlBadge} ${styles.tlBadgeMiss}`}>No out</span>
              : d.inProg
                ? <span className={`${styles.tlBadge} ${styles.tlBadgeProg}`}>Now</span>
                : <span className={`${styles.tlBadge} ${styles.tlBadgeOut}`}>{d.co} PM</span>
            }
            <span className={`${styles.tlDur}`}>{d.h} worked</span>
          </div>
        </div>

        {/* ── Info rows ── */}
        <div className={`${styles.modalBody}`}>
          <div className={`${styles.infoRow}`}>
            <span className={`${styles.irLbl}`}>⏱ Scheduled shift</span>
            <span className={`${styles.irVal}`}>{d.sched || "—"}</span>
          </div>
          <div className={`${styles.infoRow}`}>
            <span className={`${styles.irLbl}`}>◎ Shift target</span>
            <span className={`${styles.irVal}`}>{d.target ? `${tH}h 00m` : "—"}</span>
          </div>
          <div className={`${styles.infoRow} ${styles.infoRowLast}`}>
            <span className={`${styles.irLbl}`}>⌛ Total worked</span>
            <span className={workedCls}>{d.h}</span>
          </div>

          {isOt && !otState && (
            <div className={`${styles.otBox}`}>
              <div className={`${styles.otBoxTitle}`}>⚠ Overtime detected</div>
              <div className={`${styles.otAmount}`}>{fmtOt(d.otMin)} overtime</div>
              <div className={`${styles.otDesc}`}>
                Worked {fmtOt(d.otMin)} beyond the {tH}h scheduled shift.
                Approve to confirm paid overtime, or decline to mark as unpaid.
              </div>
            </div>
          )}

          {isOt && !otState && (
            <div className={`${styles.shiftSection}`}>
              <button className={`${styles.shiftToggleBtn}`} onClick={openShift}>
                ✏ {shiftOpen ? "Hide shift editor" : "Adjust shift hours (optional)"}
              </button>
              {shiftOpen && (
                <div className={`${styles.shiftEditBody}`}>
                  <div className={`${styles.seLbl}`}>Override shift hours</div>
                  <div className={`${styles.shiftInputs}`}>
                    <input className={`${styles.shiftInput}`} type="time" value={shiftStart} onChange={e => setShiftStart(e.target.value)} aria-label="Shift start" />
                    <span className={`${styles.shiftSep}`}>–</span>
                    <input className={`${styles.shiftInput}`} type="time" value={shiftEnd} onChange={e => setShiftEnd(e.target.value)} aria-label="Shift end" />
                    <button className={`${styles.applyBtn} ${saved ? styles.applyBtnSaved : ""}`} onClick={handleApply}>
                      {saved ? "Saved ✓" : "Apply"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Footer ── */}
        <div className={`${styles.modalFooter}`}>
          {otState ? (
            <>
              <span className={`${styles.footerStatus} ${otState === "approved" ? styles.footerOk : styles.footerNo}`}>
                {otState === "approved" ? "✓" : "✕"} OT {otState}
              </span>
              <button className={`${styles.btnSecondary}`} onClick={onClose}>Close</button>
            </>
          ) : isOt ? (
            <>
              <button className={`${styles.btnDanger}`} onClick={() => onResolve("declined")}>Decline OT</button>
              <button className={`${styles.btnPrimary}`} onClick={() => onResolve("approved")}>✓ Approve OT</button>
            </>
          ) : (
            <button className={`${styles.btnSecondary}`} onClick={onClose}>Close</button>
          )}
        </div>

      </div>
    </div>
  );
}

// ─── Main export ──────────────────────────────────────────────────────────────
export default function TimeTracking() {
  const [otStates, setOtStates] = useState({});
  const [modal, setModal] = useState(null); // { empId, dayIdx }

  const openModal = (empId, dayIdx) => setModal({ empId, dayIdx });
  const closeModal = () => setModal(null);
  const resolveOT = state => {
    if (!modal) return;
    setOtStates(prev => ({ ...prev, [`${modal.empId}-${modal.dayIdx}`]: state }));
    closeModal();
  };

  const modalEmp = modal ? EMPLOYEES.find(e => e.id === modal.empId) : null;

  const selectedDayIdx = DAY_VIEW_IDX;
  const selectedDayLabel = `Friday, May 9, 2026`;

  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs().format('YYYY-MM-DDDD'));
  const [weekOffset, setWeekOffset] = useState(0);
  const [dateRange, setDateRange] = useState({ start: dayjs().startOf('isoWeek').format('YYYY-MM-DD'), end: dayjs().endOf('isoWeek').format('YYYY-MM-DD') });
  const [dateRangeText, setDateRangeText] = useState('');
  const [filterData, setFilterData] = useState({ property: '0', role: '' });
  const [activeView, setActiveView] = useState("Week");
  const [widgetData, setWidgetData] = useState({ total_hours: 0, total_wages: 0, total_emplyeee: 0, late_check_in: 0, missed_checkouts: 0 });

  useEffect(() => {
    const getUserList = async () => {
      setContentLoading(true);

      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/time-tracking-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { start_date: dateRange?.start, end_date: dateRange?.end }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
        console.log(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    }

    getUserList();
  }, [getAccessTokenSilently, dateRange]);

  useEffect(() => {
    if (activeView === 'Day') {
      setDateRange({ start: dayjs(selectedDate).format('YYYY-MM-DD'), end: dayjs(selectedDate).format('YYYY-MM-DD') });
    }
    if (activeView === 'Week') {
      setDateRange({ start: dayjs().add(weekOffset, "week").startOf('isoWeek').format('YYYY-MM-DD'), end: dayjs().add(weekOffset, "week").endOf('isoWeek').format('YYYY-MM-DD') });
    }
  }, [weekOffset, selectedDate, activeView]);

  useEffect(() => {
    if (dayjs(dateRange?.start)?.format('YYYY') === dayjs(dateRange?.end)?.format('YYYY')) {
      if (dayjs(dateRange?.start)?.format('MMM') === dayjs(dateRange?.end)?.format('MMM')) {
        setDateRangeText(dayjs(dateRange?.start)?.format('MMM') + ' ' + dayjs(dateRange?.start)?.format('D') + ' - ' + dayjs(dateRange?.end)?.format('D') + ', ' + dayjs(dateRange?.start)?.format('YYYY'));
      } else {
        setDateRangeText(dayjs(dateRange?.start)?.format('MMM') + ' ' + dayjs(dateRange?.start)?.format('D') + ' - ' + dayjs(dateRange?.end)?.format('MMM') + ' ' + dayjs(dateRange?.end)?.format('D') + ', ' + dayjs(dateRange?.start)?.format('YYYY'));
      }
    } else {
      setDateRangeText(dayjs(dateRange?.start)?.format('MMM') + ' ' + dayjs(dateRange?.start)?.format('D') + ', ' + dayjs(dateRange?.start)?.format('YYYY') + ' - ' + dayjs(dateRange?.end)?.format('MMM') + ' ' + dayjs(dateRange?.end)?.format('D') + ', ' + dayjs(dateRange?.end)?.format('YYYY'));
    }
  }, [dateRange]);



  useEffect(() => {
    let filteredDataTemp = [...allData];

    if (parseInt(filterData?.property) > 0) {
      filteredDataTemp = filteredDataTemp?.filter(i => i?.property_ids.includes(parseInt(filterData?.property)));
    }

    if (filterData?.role !== '' && filterData?.role !== 'all') {
      filteredDataTemp = filteredDataTemp?.filter(i => i?.role_id === filterData?.role);
    }

    setFilteredData(filteredDataTemp);
  }, [allData, filterData]);

  useEffect(() => {
    console.log('allData');
    console.log(allData);

    let total_hours = 0;
    let total_wages = 0;
    let total_emplyeee = 0;
    let late_check_in = 0;
    let missed_checkouts = 0;

  }, [allData]);

  return (
    <div className={`${styles.page}`}>

      {/* ── Topbar ── */}
      <div className={`${styles.topbar}`}>
        <div>
          <div className={`${styles.pageEyebrow}`}>HR &amp; Workforce</div>
          <div className={`${styles.pageTitle}`}>
            Time Tracking
          </div>
        </div>
        <div className={`${styles.topbarRight}`}>
          <div className={`${styles.viewTabs}`}>
            {["Day", "Week"].map(v => (<button key={v} className={`${styles.vtab} ${activeView === v ? styles.vtabOn : ""}`} onClick={() => { setActiveView(v); setSelectedDate(dayjs().format('YYYY-MM-DDDD')); setWeekOffset(0); }}>{v}</button>))}
          </div>
          <div className={`${styles.weekNav}`}>
            <button className={`${styles.navBtn}`} aria-label="Prev" onClick={(e) => { setWeekOffset(e => e - 1); setSelectedDate(dayjs(selectedDate).subtract(1, 'day').format('YYYY-MM-DDDD')); }}>‹</button>
            <span className={`${styles.weekLbl}`}>{activeView === "Day" ? dayjs(selectedDate).format('MMM D, YYYY') : dateRangeText}</span>
            <button className={`${styles.navBtn}`} aria-label="Next" onClick={(e) => { setWeekOffset(e => e + 1); setSelectedDate(dayjs(selectedDate).add(1, 'day').format('YYYY-MM-DDDD')); }}>›</button>
          </div>
        </div>
      </div>

      {/* ── Stats ── */}
      <div className={`${styles.stats}`}>
        <div className={`${styles.scard}`}>
          <div className={`${styles.scardLbl}`}>Total hours</div>
          <div className={`${styles.scardVal}`}>{widgetData?.total_hours}</div>
        </div>
        <div className={`${styles.scard}`}>
          <div className={`${styles.scardLbl}`}>Total Wages</div>
          <div className={`${styles.scardVal}`}>{widgetData?.total_wages}</div>
        </div>
        <div className={`${styles.scard}`}>
          <div className={`${styles.scardLbl}`}>Employees tracked</div>
          <div className={`${styles.scardVal}`}>{widgetData?.total_emplyeee}</div>
        </div>
        <div className={`${styles.scard}`}>
          <div className={`${styles.scardLbl}`}>Late clock-ins</div>
          <div className={`${styles.scardVal} ${styles.scardValWarn}`}>{widgetData?.late_check_in}</div>
        </div>
        <div className={`${styles.scard}`}>
          <div className={`${styles.scardLbl}`}>Missed clock-outs</div>
          <div className={`${styles.scardVal} ${styles.scardValDanger}`}>{widgetData?.missed_checkouts}</div>
        </div>
      </div>


      <div className={`${styles.tblHeader}`}>
        {activeView === "Week" && <div className={`${styles.tblTitle}`}>Weekly timesheets</div>}
        {activeView === "Day" && <div className={`${styles.dvDayTitle}`}>{dayjs(selectedDate).format('dddd, MMM D, YYYY')}</div>}

        <Filter setFilterData={setFilterData.bind(this)} />
      </div>

      {/* ══ WEEK VIEW ══ */}
      {activeView === "Week" && (
        <>
          <WeekViewTable contentLoading={contentLoading} filteredData={filteredData} dateRange={dateRange} />

          <div className={`${styles.legend}`}>
            <span className={`${styles.legItem}`}><span className={`${styles.legIn}`}>9:00</span> clock-in</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legOut}`}>5:00</span> clock-out</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#534AB7" }} />Normal</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#EF9F27" }} />Overtime</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#E24B4A" }} />Late</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#378ADD" }} />In progress</span>
            <span className={`${styles.legItem}`}>Click any cell to review</span>
          </div>
        </>
      )}

      {activeView === "Day" && (
        <>
          <DayViewTable contentLoading={contentLoading} filteredData={filteredData} />

          <div className={`${styles.legend}`}>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#EEEDFE", border: "1px solid #c5c0ee", display: "inline-block" }} /> Scheduled</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#534AB7" }} />Worked</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#EF9F27" }} />Overtime</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#E24B4A" }} />Late</span>
            <span className={`${styles.legItem}`}><span className={`${styles.legDot}`} style={{ background: "#378ADD" }} />In progress</span>
            <span className={`${styles.legItem}`}>Click any row to review</span>
          </div>
        </>
      )}

      {/* ── Modal ── */}
      {modal && modalEmp && (
        <DayModal
          emp={modalEmp}
          dayIdx={modal.dayIdx}
          otState={otStates[`${modal.empId}-${modal.dayIdx}`]}
          onClose={closeModal}
          onResolve={resolveOT}
        />
      )}

    </div>
  );
}
